module.exports = __webpack_public_path__ + "static/media/resume-2022.7fd8ecdc.pdf";